<app-metformin
  htmlTitle="<strong>Metformin: A deeper approach to acne control</strong>"
  question="We strongly recommend including Metformin in your prescription. Would you like to add it to your treatment plan?"
>
  <p class="mb-4">
    For some patients, acne is driven by internal metabolic and hormonal signals. Metformin helps address those
    underlying factors to support clearer, more consistent results.
  </p>
  <p class="mb-3"><strong>Metformin = internal balance for acne-prone skin</strong></p>
  <p class="mb-3">
    <strong>Daily: regulate + reduce breakouts</strong><br />
    Helps improve insulin sensitivity, which can lower excess oil production and acne-triggering inflammation,
    especially in patients with hormonal patterns or breakouts that don’t fully respond to topicals alone.
  </p>
  <p class="mb-4">
    <strong>Long-term: support sustained results</strong><br />
    Works alongside doxycycline and topical treatments to help reduce recurring or stubborn acne. Addresses internal
    contributors that can lead to ongoing flare-ups.
  </p>
  <p class="mb-1"><strong>Why add it?</strong></p>
  <ul class="mb-4">
    <li>Targets internal drivers of hormonal acne.</li>
    <li>Helps reduce oil production and inflammation.</li>
    <li>Complements topical and oral acne treatments.</li>
    <li>Supports longer-lasting acne control.</li>
  </ul>
</app-metformin>
